/* globals lp,Class */
var ubBanzai = require('ub/control/banzai-features');
var formGeometry = require('ub/elements/form/geometry').default;

function selectMainJsFilename() {
  var path = 'modules/lp-form/public/';
  if (ubBanzai.features.isBetterPhoneValidationEnabled()) {
    return path + 'main.js';
  } else {
    return path + 'main-pre.js';
  }
}

var FormModule = Class.create(
    lp.ModuleBase,
    lp.ModuleElementMethods,
    lp.ModuleElementBuilderMethods,
    lp.ModuleElementPropertiesPanelMethods,
    {
      getLimit: function() {
        return 1;
      },
      jQueryPlugins : [
        lp.getPublishedAssetsUrl('published/jquery.validate.min.js'),
        lp.getPublishedAssetsUrl('published/additional-methods.js'),
        lp.getPublishedAssetsUrl('published/jquery.ubpoverlay.js')
      ],
      stylesheets   : [
        lp.getPublishedAssetsUrl('published/jquery.ubpoverlay.css')
      ],
      javascripts   : [
        lp.getPublishedAssetsUrl('published/matchMedia.js'),
        // the text module is require for line wrapping fixes
        lp.getPublishedAssetsUrl('modules/lp-text/public/main.js'),
        lp.getPublishedAssetsUrl(selectMainJsFilename())
      ],

      beforeCreate: function(page, defaults, options, fields) {
        defaults.content.fields = fields;

        defaults.content.confirmTarget = page.getConfigValue('formTargetDefault');

        if (page.allowExternalLightboxes()) {
          defaults.lightboxSize = lp.module.form.FormElement.lightboxSizeDefault;
        }

        page.undoManager.startGroup();
      },

      afterInsert: function(element, options) {
        if (element.page.isEditMode()) {
          element.createDependantElements();
        }

        if (element.page.getConfigValue('setFormColumnsAutomatically')) {
          formGeometry.setFieldWidthByFieldCount(element);
        }

        if (options.center) {
          var size = element.model.getSize();
          element.model.setOffset({
            left: options.offset.left,
            top: options.offset.top - Math.round(size.height / 2)
          });
        }

        element.page.undoManager.endGroup();
      },

      getTransformBoxUIExtensions: function(elm) {
        /* jshint unused:vars */

        this.labelWidthIndicator = this.labelWidthIndicator ||
          new lp.module.form.LabelWidthControlTransformBoxExtension();
        return [
        {
          placement: this.labelWidthIndicator.updateUI.bind(this.labelWidthIndicator),
          component: this.labelWidthIndicator
        }
        ];
      }
    }
);

lp.addModule(new FormModule( {
  type:'lp-pom-form',
  isAllowedOnPage: function(page) {
    return page.getConfigValue('allowFormWidget');
  },
  version:'1.7.2',
  name: 'Form',
  usageType:'page-widget',
  namespace: lp.module.form
}));

module.exports = FormModule;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-form/form_module.js
// module id = 558
// module chunks = 0 1